import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { addGlobalSearchHistoryEntry } from "features/global-search/model/persistent-global-search-history-store"
import { useGlobalSearch } from "features/global-search/model/useGlobalSearch"
import { useNavigateToGlobalSearchResult } from "features/global-search/model/useNavigateToGlobalSearchResult"
import { GlobalSearchOption } from "features/global-search/types/GlobalSearch"

import { GlobalSearchOverlayModel } from "../GlobalSearchOverlay"

export function useGlobalSearchOverlayModel(): GlobalSearchOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { options, isLoading, searchTerm, onSearchTermChange, history } =
    useGlobalSearch({})
  const onChange = useNavigateToGlobalSearchResult()

  const handleChange = useEvent((option: GlobalSearchOption | null) => {
    if (option && searchTerm?.trim()) {
      addGlobalSearchHistoryEntry(searchTerm)
    }
    onChange(option)
    closeOverlay()
  })

  return {
    options,
    isLoading,
    searchTerm,
    onSearchTermChange,
    onChange: handleChange,
    onClose: closeOverlay,
    history
  }
}
